var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"asyncCourse_bar",attrs:{"id":"asyncCourse_bar"}})
}
var staticRenderFns = []

export { render, staticRenderFns }